import { render, staticRenderFns } from "./pc-news.vue?vue&type=template&id=706ea576"
import script from "./pc-news.vue?vue&type=script&lang=js"
export * from "./pc-news.vue?vue&type=script&lang=js"
import style0 from "./pc-news.vue?vue&type=style&index=0&id=706ea576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports